// Shared recipe-scaling constants.
//
// The servings control used to hard-cap at 20 in four separate UI
// files (pre-cook, in-cook, schedule, meal drawer), each with its own
// inline `Math.min(20, …)`. That cap blocked buffet / crowd scaling and
// there was no way to type a number or jump by a multiple. These
// constants are the single source of truth so every surface scales the
// same way.

// Upper bound on a recipe's serving count. 100 covers party / event
// batch cooking without letting a fat-fingered keystroke push the
// ingredient math into absurd territory.
export const MAX_SERVINGS = 100;

// Lower bound — a recipe always makes at least one serving.
export const MIN_SERVINGS = 1;

// Quick-pick multipliers surfaced as ×2 / ×3 buttons next to the
// stepper. "double / triple" are the two scaling jumps a cook reaches
// for most often (a second tray, a doubled batch).
export const SERVINGS_QUICK_MULTIPLIERS = [2, 3];

// Clamp any user-entered or computed servings value into range as a
// whole number. Centralized so every call site enforces identical
// bounds before it reaches scaleRecipe().
export function clampServings(n, max = MAX_SERVINGS) {
  const v = Math.round(Number(n));
  if (!Number.isFinite(v)) return MIN_SERVINGS;
  return Math.max(MIN_SERVINGS, Math.min(max, v));
}
